import Vue from 'vue'

Vue.directive('debounce', {
    inserted: function (el, binding) {
        let [fn, event = "click", time = 300, data] = binding.value
        let timer;
        el.addEventListener(event, () => {
            timer && clearTimeout(timer)
            timer = setTimeout(() => fn(data), time)
        })
    }
})

Vue.directive('throttle', {
    inserted: function (el, binding) {
        let [fn, event = "click", time = 300] = binding.value;
        let timer, timer_end;
        el.addEventListener(event, () => {
            if(timer){
                clearTimeout(timer_end);
                return timer_end = setTimeout(() => fn(), time);
            }
            fn();
            timer = setTimeout(() => timer = null, time);
        })
    }
})

//全局注册自定义指令，用于判断当前图片是否能够加载成功，可以加载成功则赋值为img的src属性，否则使用默认图片
Vue.directive('real-img', async function (el, binding) {//指令名称为：real-img
    let imgURL = binding.value;//获取图片地址
    if (imgURL) {
        let exist = await imageIsExist(imgURL);
        if (exist) {
            el.setAttribute('src', imgURL);
        }
    }
})

/**
 * 检测图片是否存在
 * @param url
 */
let imageIsExist = function(url) {
    return new Promise((resolve) => {
        var img = new Image();
        img.onload = function () {
            if (this.complete == true){
                resolve(true);
                img = null;
            }
        }
        img.onerror = function () {
            resolve(false);
            img = null;
        }
        img.src = url;
    })
}

/**
 * 防止按钮重复点击
 * v-preventReClick(使用时)
 */
 const preventReClick = Vue.directive('preventReClick', {
    inserted(el, binding) {
      el.addEventListener('click', e => {
        if (!el.disabled) {
          el.disabled = true
          el.style.cursor = 'not-allowed'
          setTimeout(() => {
            el.style.cursor = 'pointer'
            el.disabled = false
          }, binding.value || 3000)
        }
      })
    }
  })
  export { preventReClick }